import FilmCard from "@/components/feature/FilmCard";
import { films } from "@/mocks/films";
import type { Film } from "@/types/content";

interface RelatedFilmsProps {
  film: Film;
}

export default function RelatedFilms({ film }: RelatedFilmsProps) {
  const related = (films as Film[])
    .filter((item) => item.id !== film.id)
    .filter(
      (item) =>
        item.genres.some((g) => film.genres.includes(g)) ||
        item.tags.some((t) => film.tags.includes(t)),
    )
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="max-w-content mx-auto px-4 md:px-8 py-14 border-t border-background-200/60">
      <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-8">相关影片推荐</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {related.map((item) => (
          <FilmCard key={item.id} film={item} />
        ))}
      </div>
    </section>
  );
}